var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tab',{attrs:{"href":_vm.id}},[_c('v-badge',{attrs:{"bordered":"","color":"error","overlap":"","offset-y":"5","offset-x":"3","content":_vm.total}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }